import { Platform, StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    position: 'relative',
    overflow: 'hidden',
    flexDirection: 'row',
    alignContent: 'center',
    alignItems: 'flex-end',
    gap: 20,

    borderRadius: 16,
    height: '100%',
    paddingHorizontal: 20,
  },
  container_gesture_handler: {
    width: 220,
    height: 55,
    paddingBottom: 10,
    overflow: 'hidden',
    justifyContent: 'flex-end',
    alignContent: 'center',
    alignSelf: 'center',
  },
  slide: {
    width: 220,
    height: 12,
    marginBottom: 2,
    cursor: 'pointer',
  },
  pin: {
    height: 8.78,
    width: 0.1,
    borderWidth: 1.3,
    borderRadius: 10,
    cursor: 'pointer',
  },
  central_number: {
    fontSize: 13.17,
    color: neutrals.neutralGrays.graphite,
    fontWeight: 400,
    lineHeight: 17.56,
    paddingLeft: 5,
  },
  central_pin: {
    width: 0.1,
    height: 15.37,
    borderWidth: 1.92,
    borderRadius: 10,
  },
  central_pin_container: {
    position: 'absolute',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 6,
    width: 220,
    height: 40,
  },
  linear_gradient: {
    zIndex: 1,
    position: 'absolute',
    width: 39.16,
    height: 20,
    bottom: 10,
    cursor: 'pointer',
  },
  linear_gradient_left: {
    right: 0,
    transform: [{ scaleX: -1 }],
  },
  linear_gradient_right: {
    left: 0,
  },
  buttonRotate: {
    borderWidth: 2,
    borderColor: 'transparent',
    marginBottom: 15,
  },
  buttonRotateFocus: {
    borderColor: FOCUS_COLOR,
  },
  icon: {
    width: 24,
    height: 24,
    color: neutrals.neutralGrays.ash,
  },
  hoverTextContainer: {
    position: 'absolute',
    bottom: 25, // Posizionato sopra l'icona
    backgroundColor: neutrals.white,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverTextContainerRight: {
    position: 'absolute',
    bottom: 25, // Posizionato sopra l'icona
    right: 0,
    backgroundColor: neutrals.white,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6, //12* 130%
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
});
